import {ProposalStatus} from "../../types/Proposal";
import {ReactNode} from "react";
import Stack from "@mui/material/Stack";

export function ProposalStatusBadge ({includeHints, contentBefore, style, status}:{includeHints?:boolean, contentBefore?:string|ReactNode,style?:React.CSSProperties,status:ProposalStatus}) {
    const value = <div className={"proposal-status"} style={{background: defineColor(status), ...(style||{})}}>
        {contentBefore}{defineLabel(status)}
    </div>

    if(!includeHints){
        return value
    }
    return <Stack flexDirection={"row"} gap={"15px"}>
        {value}
        {defineHint(status)}
    </Stack>
}

function defineHint(status: ProposalStatus): string {
    switch (status) {
        case 'DELETED':
            return 'The proposal has been logically deleted';
        case 'AUTO_INITIAL':
            return 'The proposal is incomplete; automatic completion is scheduled';
        case 'AUTO_INCOMPLETE':
            return 'The proposal is incomplete; waiting for manual completion';
        case 'REJECTED':
            return 'Rejected as advertisement';
        case 'AUTO_COMPLETE':
            return 'The proposal was not approved by our specialist';
        case 'MANUAL':
            return 'The proposal was entered manually and is not yet approved';
        case 'AUTO_ERROR':
            return 'An error occurred during automatic completion';
        case 'OWNER':
            return 'The proposal was submitted by the property owner';
        case 'AGENT':
            return 'The proposal was submitted by an agent';
        case 'SOLD':
            return 'The property has already been sold';
        case 'NO_RESPONSE':
            return 'Our specialist was unable to reach the provided phone number';
    }
}
function defineLabel(status:ProposalStatus):string {
    switch (status) {
        case 'DELETED':
            return 'DELETED'
        case 'AUTO_INITIAL':
            return 'INITIAL'
        case 'AUTO_INCOMPLETE':
            return 'INCOMPLETE'
        case 'REJECTED':
            return 'AD';
        case 'AUTO_COMPLETE':
            return 'AWAIT'
        case 'MANUAL':
            return 'MANUAL'
        case 'AUTO_ERROR':
            return 'ERROR'
        case 'OWNER':
            return 'OWNER'
        case 'AGENT':
            return 'AGENT'
        case 'SOLD':
            return 'SOLD'
        case 'NO_RESPONSE':
            return 'NO RESPONSE'
    }
}

function defineColor(status:ProposalStatus) {
    switch (status) {
        case 'AUTO_COMPLETE':
        case 'MANUAL':
            return '#5080a8';
        case 'DELETED':
        case 'REJECTED':
        case 'SOLD':
        case 'AUTO_ERROR':
            return '#e38888'
        case 'NO_RESPONSE':
            return '#daca7c';
        case 'OWNER':
        case 'AGENT':
            return '#95e184'
        case 'AUTO_INCOMPLETE':
        case 'AUTO_INITIAL':
        default:
            return '#bababa';
    }
}